<template>
  <v-row>
    <v-col
      v-if="arrayVazio"
      class="text-subtitle-1 text-center mt-12"
      cols="12"
    >
      Sem dados para gerar relatório
    </v-col>

    <v-col
      v-if="loading"
      class="text-subtitle-1 text-center mt-12"
      cols="12"
    >
      Carregando . . .
    </v-col>

    <v-col
      cols="6"
      class="mx-auto"
      :class="!loading ? 'd-none' : ''"
    >
      <v-progress-linear
        v-if="loading"
        class=""
        style="min-height: 10px"
        indeterminate
        rounded
      />
    </v-col>

    <v-col
      v-if="!loading"
      cols="12"
      class="mx-auto mt-2"
    >
      <v-card
        v-for="(group, date) in groupedData"
        :key="date"
        class="mt-5"
      >
        <v-card-title class="align-start">
          <span class="font-weight-semibold">Data: {{ formatDate(date) }}</span>
        </v-card-title>

        <v-card
          v-for="(data, index) in group"
          :key="index"
          class="mb-2 ma-2 py-5"
          elevation="3"
        >
          <v-card-text
            class="mr-0"
          >
            <v-row>
              <v-col
                cols="12"
                md="3"
                class="d-flex align-center"
              >
                <v-avatar
                  size="44"
                  color="error"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiAccount }}
                  </v-icon>
                </v-avatar>

                <div class="ms-3">
                  <p class="text-xs mb-0">
                    Agente
                  </p>
                  <h3 class="text-xl font-weight-semibold">
                    {{ data.agenteNome }}
                  </h3>
                </div>
              </v-col>

              <v-col
                md="3"
                class="d-flex align-center"
              >
                <v-avatar
                  size="44"
                  color="warning"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiPlusBoxMultiple }}
                  </v-icon>
                </v-avatar>

                <div class="ms-3">
                  <v-tooltip
                    top
                    color="primary"
                  >
                    <template #activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                      >
                        <p class="text-xs mb-0">
                          Filas
                        </p>

                        <h3 class="text-xl font-weight-semibold">
                          {{ data.filas.length }}
                        </h3>
                      </div>
                    </template>

                    <ul style="padding: 0;">
                      <li
                        v-for="(fila, filaIndex) in data.filas"
                        :key="filaIndex"
                        :class="filaIndex === 0 || filaIndex === (data.filas.length - 1) ? 'mb-1 mt-1' : 'my-2'"
                        style="list-style: none; padding-left: 0;"
                      >
                        <v-chip color="info">
                          {{ fila }}
                        </v-chip>
                      </li>
                    </ul>
                  </v-tooltip>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="3"
                class="d-flex align-center"
              >
                <v-avatar
                  size="44"
                  color="success"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiClockTimeEightOutline }}
                  </v-icon>
                </v-avatar>

                <div class="ms-3">
                  <p class="text-xs mb-0">
                    Tempo Logado (hh:mm)
                  </p>
                  <h3 class="text-xl font-weight-semibold">
                    {{ data.tempoLogado }}
                  </h3>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="3"
                class="d-flex align-center"
              >
                <v-avatar
                  size="44"
                  color="accent"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiStopCircleOutline }}
                  </v-icon>
                </v-avatar>

                <div class="ms-3">
                  <p class="text-xs mb-0">
                    Tempo de Pausa (hh:mm)
                  </p>
                  <h3 class="text-xl font-weight-semibold">
                    {{ data.tempoEmPausa }}
                  </h3>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiPlusBoxMultiple, mdiClockTimeEightOutline, mdiStopCircleOutline, mdiAccount } from '@mdi/js'

export default {
  props: {
    groupedData: {
      type: Object,
      required: true,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    arrayVazio: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const formatDate = date => {
      if (!date) return null
      const dates = date.split('T')
      const [year, month, day] = dates[0].split('-')
      return `${day}/${month}/${year}`
    }
    const dateFormatted = computed(() => formatDate())

    return {
      formatDate,
      dateFormatted,
      icons: {
        mdiStopCircleOutline,
        mdiPlusBoxMultiple,
        mdiClockTimeEightOutline,
        mdiAccount,
      },
    }
  },
}
</script>
